import { render, staticRenderFns } from "./AccountInfoEdit.vue?vue&type=template&id=2cb1a257&"
import script from "./AccountInfoEdit.vue?vue&type=script&lang=js&"
export * from "./AccountInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports